import { IconButton } from '../../../common/IconButton';
import { Tooltip } from 'react-tooltip';
import { launcherElementInfo } from '../../../../info/launcherElementInfo';
import styled from 'styled-components';
import { toolbarInfo } from '../../../../info/toolbarInfo';
import { useLauncherElementsStore } from '../../../../hooks/stores/launcherElementsStore';
import { useMemo } from 'react';
import { useScene } from '../../../../context/sceneContext';
import { useUIStore } from '../../../../hooks/stores/uiStore';

export const SidebarToolbarIcons = () => {
  const scene = useScene();
  const [UIData] = useUIStore();
  const [launcherElementsData] = useLauncherElementsStore();
  // TODO: add back licensePopup functionality
  // const isLicensePopupAdded = useMemo(() => Object.keys(launcherElementsData).some(
  //   (id) => id === 'appLicenseKeyPopup'
  // ), [launcherElementsData]);

  return (
    <>
      <ScrollContainer className="scroll" $isDisabled={UIData.editorMode === 'simulation'}>
        {toolbarInfo.map(({ elementType, tooltip }) => (
          <div key={elementType}>
            <div id={`toolbar-${elementType}`}>
              <IconButton
                iconClassName={launcherElementInfo[elementType]?.iconClassName}
                onClick={() => scene.addElement(elementType)}
                // TODO: add back licensePopup functionality
                // isDisabled={elementType === 'licensePopup' && isLicensePopupAdded}
              />
            </div>
            <Tooltip anchorSelect={`#toolbar-${elementType}`} place="right" content={tooltip} />
          </div>
        ))}
      </ScrollContainer>
      <div id="toolbar-feedback">
        <IconButton
          iconClassName='icon-bug'
          onClick={() => scene.openModal('feedbackModal')}
          iconSize={24}
        />
      </div>
      <Tooltip anchorSelect="#toolbar-feedback" place="right" content="Report a Bug" />
    </>
  );
};

const ScrollContainer = styled.div<{ $isDisabled: boolean }>`
  box-sizing: border-box;
  width: 100%;
  padding: 0 4px;
  height: calc(100vh - 100px);
  overflow-x: visible;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${({ $isDisabled }) => $isDisabled && `
    opacity: 0.5;
    pointer-events: none;
  `}
`;
